import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, ProtectedRoute } from "./contexts/AuthContext";
import { SiteDataProvider } from "./contexts/SiteDataContext";

// Public Pages
import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import CategoriesPage from "./pages/CategoriesPage";
import CategoryDetail from "./pages/CategoryDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";

// Admin Pages
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/Dashboard";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminProductForm from "./pages/admin/AdminProductForm";
import AdminCategories from "./pages/admin/AdminCategories";
import AdminBanners from "./pages/admin/AdminBanners";
import AdminPages from "./pages/admin/AdminPages";
import AdminMedia from "./pages/admin/AdminMedia";
import AdminImportExport from "./pages/admin/AdminImportExport";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminChangePassword from "./pages/admin/AdminChangePassword";
import AdminClients from "./pages/admin/AdminClients";
import AdminTestimonials from "./pages/admin/AdminTestimonials";
import ClientAuth from "./pages/ClientAuth";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SiteDataProvider>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/produtos" element={<Products />} />
            <Route path="/produto/:id" element={<ProductDetail />} />
            <Route path="/categorias" element={<CategoriesPage />} />
            <Route path="/categorias/:slug" element={<CategoryDetail />} />
            <Route path="/sobre" element={<About />} />
            <Route path="/contato" element={<Contact />} />
            <Route path="/entrar" element={<ClientAuth />} />
            
            {/* Admin Routes */}
            <Route path="/dashboard/login" element={<AdminLogin />} />
            <Route path="/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/dashboard/produtos" element={<ProtectedRoute><AdminProducts /></ProtectedRoute>} />
            <Route path="/dashboard/produtos/novo" element={<ProtectedRoute><AdminProductForm /></ProtectedRoute>} />
            <Route path="/dashboard/produtos/:id" element={<ProtectedRoute><AdminProductForm /></ProtectedRoute>} />
            <Route path="/dashboard/categorias" element={<ProtectedRoute><AdminCategories /></ProtectedRoute>} />
            <Route path="/dashboard/banners" element={<ProtectedRoute><AdminBanners /></ProtectedRoute>} />
            <Route path="/dashboard/paginas" element={<ProtectedRoute><AdminPages /></ProtectedRoute>} />
            <Route path="/dashboard/midia" element={<ProtectedRoute><AdminMedia /></ProtectedRoute>} />
            <Route path="/dashboard/importar" element={<ProtectedRoute><AdminImportExport /></ProtectedRoute>} />
            <Route path="/dashboard/configuracoes" element={<ProtectedRoute><AdminSettings /></ProtectedRoute>} />
            <Route path="/dashboard/senha" element={<ProtectedRoute><AdminChangePassword /></ProtectedRoute>} />
            <Route path="/dashboard/clientes" element={<ProtectedRoute><AdminClients /></ProtectedRoute>} />
            <Route path="/dashboard/depoimentos" element={<ProtectedRoute><AdminTestimonials /></ProtectedRoute>} />
          </Routes>
          </SiteDataProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
